import { render } from "./RedDivider.vue?vue&type=template&id=30c0a4c2&scoped=true"
import script from "./RedDivider.vue?vue&type=script&lang=js"
export * from "./RedDivider.vue?vue&type=script&lang=js"

import "./RedDivider.vue?vue&type=style&index=0&id=30c0a4c2&lang=scss&scoped=true"

import exportComponent from "E:\\_www\\gxbxxh\\view\\index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c0a4c2"]])

export default __exports__